export const doctors = [
  {
    id: 1,
    slug: "dr-thousif-ahammed",
    name: "Dr. Thousif Ahammed",
    qualification: "BDS",
    designation: "Lead Dental Surgeon",
    image: "/images/dr-thousif.jpeg",
    imageAlt: "Dr. Thousif Ahammed - Lead Dental Surgeon at Olive Dental Clinic",
    experience: "15+ Years",
    isChief: true,
    branches: [
      "mangalam",
      "koottayi",
      "vettom"
    ],
    specialties: [
      "Root Canal Treatment",
      "Dental Implants",
      "Cosmetic Dentistry",
      "General Dentistry",
      "Smile Designing"
    ],
    description: "Experienced dental surgeon providing advanced dental care, cosmetic dentistry, root canal treatment and dental implants.",
    seo: {
      title: "Dr. Thousif Ahammed | Olive Dental Clinic",
      description: "Meet Dr. Thousif Ahammed, Lead Dental Surgeon at Olive Dental Clinic with over 13 years of experience."
    }
  },
  {
    id: 2,
    slug: "dr-afsa-abdulkader",
    name: "Dr. Afsa Abdulkader",
    qualification: "BDS",
    designation: "Dental Surgeon",
    image: "/images/dr-afsa.jpeg",
    imageAlt: "Dr. Afsa Abdulkader - Dental Surgeon at Olive Dental Clinic",
    experience: "15+ Years",
    isChief: false,
    branches: [
      "vettom"
    ],
    specialties: [
      "General Dentistry",
      "Preventive Care"
    ],
    description: "Providing comprehensive general dentistry with a patient-friendly approach.",
    seo: {
      title: "Dr. Afsa Abdulkader | Olive Dental Clinic",
      description: "Dental Surgeon at Olive Dental Clinic, Vettom."
    }
  },
  {
    id: 3,
    slug: "dr-suhainath",
    name: "Dr. Suhainath",
    qualification: "BDS",
    designation: "Dental Surgeon",
    image: "/images/dr-suhainath.jpeg",
    imageAlt: "Dr. Suhainath - Dental Surgeon at Olive Dental Clinic",
    experience: "8+ Years",
    isChief: false,
    branches: [
      "koottayi"
    ],
    specialties: [
      "General Dentistry",
      "Tooth Extraction"
    ],
    description: "Experienced Dental Surgeon providing quality dental care.",
    seo: {
      title: "Dr. Suhainath | Olive Dental Clinic",
      description: "Dental Surgeon at Olive Dental Clinic, Koottayi."
    }
  },
  {
    id: 4,
    slug: "dr-thamseela",
    name: "Dr. Thamseela",
    qualification: "BDS",
    designation: "Dental Surgeon",
    image: "/images/dr-thamseela.png",
    imageAlt: "Dr. Thamseela - Former Consultant Dental Surgeon",
    experience: "8+ Years",
    isChief: false,
    branches: [],
    specialties: [
      "Kids Dentistry",
      "General Dentistry"
    ],
    description: "Former Consultant Dental Surgeon at Olive Dental Clinic.",
    seo: {
      title: "Dr. Thamseela | Olive Dental Clinic",
      description: "Former Consultant Dental Surgeon at Olive Dental Clinic."
    }
  }
];

// ============================================================
// HELPER FUNCTIONS - ALL EXPORTED
// ============================================================

// Get the chief doctor
export const getChiefDoctor = () =>
  doctors.find((doctor) => doctor.isChief);

// Get doctor by ID
export const getDoctorById = (id) =>
  doctors.find((doctor) => doctor.id === id);

// Get doctor by slug
export const getDoctorBySlug = (slug) =>
  doctors.find((doctor) => doctor.slug === slug);

// Get all doctor names
export const getDoctorNames = () =>
  doctors.map((doctor) => doctor.name);

// Get doctors by specialty (case-insensitive)
export const getDoctorsBySpecialty = (specialty) =>
  doctors.filter((doctor) =>
    doctor.specialties.some(
      (item) => item.toLowerCase() === specialty.toLowerCase()
    )
  );

// Get all unique specialties
export const getAllSpecialties = () => {
  const all = doctors.flatMap(d => d.specialties);
  return [...new Set(all)];
};

// Get doctors by branch (returns doctors with non-empty branch list)
export const getDoctorsByBranch = (branch) =>
  doctors.filter((doctor) => 
    doctor.branches && doctor.branches.length > 0 && doctor.branches.includes(branch)
  );